/**
 * Конфиг для таблицы списка заказов
 * @module PageOrders/ordersTableConfig
 * */

export default [
  {
    title: 'Карточка заказа',
    name: 'orderCard',
    value: 'Карточка заказа',
    type: 'button',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'width: 180px'
  },
  {
    title: 'Номер заказа',
    field: 'orderNumber',
    name: 'orderNumber',
    hidden: false,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 180px'
  },
  {
    title: 'Номер магазина',
    field: 'shopNumber',
    name: 'shopNumber',
    hidden: false,
    sortable: true,
    filterable: true,
    columnWidth: 'width: 180px'
  },
  {
    title: 'Дата создания заказа',
    field: 'orderCreatedAtDate',
    name: 'orderCreatedAtDate',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'width: 180px'
  },
  {
    title: 'Время создания заказа',
    field: 'orderCreatedAtTime',
    name: 'orderCreatedAtTime',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'width: 180px'
  },
  {
    title: 'Стоимость заказа',
    field: 'orderCost',
    name: 'orderCost',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'width: 180px'
  },
  {
    title: 'Статус заказа',
    field: 'orderStatus',
    name: 'orderStatus',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'width: 180px'
  },
  {
    title: 'Статус оплаты заказа',
    field: 'orderPaymentStatus',
    name: 'orderPaymentStatus',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'width: 180px'
  },
  {
    title: 'Статус доставки заказа',
    field: 'orderDeliveryStatus',
    name: 'orderDeliveryStatus',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'width: 180px'
  },
  {
    title: 'ФИО сборщика заказа',
    field: 'orderCollectorFullName',
    name: 'orderCollectorFullName',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'width: 180px'
  },
  {
    title: 'Адрес точки А ',
    field: 'addressFrom',
    name: 'addressFrom',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'width: 180px'
  },
  {
    title: 'Адрес точки B',
    field: 'addressTo',
    name: 'addressTo',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'width: 180px'
  },
  {
    title: 'Комментарий к заказу от клиента',
    field: 'commentFromClient',
    name: 'commentFromClient',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'width: 180px'
  },
  {
    title: '“Бесконтактная доставка”',
    field: 'contactlessDelivery',
    name: 'contactlessDelivery',
    type: 'boolean',
    hidden: false,
    sortable: true,
    filterable: false,
    format: val => (val ? 'Да' : 'Нет'),
    columnWidth: 'width: 180px'
  },
  {
    title: 'ФИО клиента, оформившего заказ',
    field: 'customerFullName',
    name: 'customerFullName',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'width: 180px'
  },
  {
    title: 'Название курьерской службы',
    field: 'courierServiceName',
    name: 'courierServiceName',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'width: 180px'
  },
  {
    title: 'ФИО курьера',
    field: 'courierFullName',
    name: 'courierFullName',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'width: 180px'
  },
  {
    title: 'Телефон курьера',
    field: 'courierPhone',
    name: 'courierPhone',
    hidden: false,
    sortable: true,
    filterable: false,
    columnWidth: 'width: 180px'
  }
]
